import { createRoute } from "@tanstack/solid-router";
// FLAGS: the entire page is gated by feature (active org).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { Contact } from "@fleet/icons";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer, PageHeader } from "@fleet/ui";
import { LeadDetail } from "@/features/crm/lead-detail";

function LeadDetailPage() {
  const { t } = useI18n();
  const params = leadDetailRoute.useParams();
  return (
    <PageContainer maxWidth="5xl">
      <PageHeader title={t(msg`Lead`)} icon={Contact} backTo="/crm" />
      <div class="mt-4">
        <LeadDetail leadId={params().leadId} />
      </div>
    </PageContainer>
  );
}

export const leadDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/crm/leads/$leadId",
  component: withFeatureGate("crm.leads", LeadDetailPage),
});
